import { NgModule } from "@angular/core";
import { PreloadAllModules, Routes, RouterModule } from "@angular/router";
import { Error404Component } from "./error404/error404.component";
import { AuthGuard } from "./guards/auth.guard";
import { LoginGuard } from "./guards/login.guard";
import { LoadingComponent } from "./loading/loading.component";

export const routes: Routes = [
  {
    path: "signin",
    loadChildren: () =>
      import("./signin/signin.module").then((m) => m.SigninModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginModule),
    canActivate: [LoginGuard],
  },
  {
    path: "print",
    loadChildren: () =>
      import("./print/print.module").then((m) => m.PrintModule),
    canActivate: [AuthGuard],
  },
  {
    path: "public",
    loadChildren: () =>
      import("./public/public.module").then((m) => m.PublicModule),
    canActivate: [LoginGuard],
  },
  { path: "loading/:path", component: LoadingComponent },
  {
    path: "mail-settings",
    loadChildren: () =>
      import("./mail-settings/mail-settings.module").then(
        (m) => m.MailSettingsModule
      ),
  },
  {
    path: "",
    loadChildren: () => import("./main/main.module").then((m) => m.MainModule),
    canActivate: [AuthGuard],
  },
  { path: "**", component: Error404Component },

  {
    outlet: "layover",
    path: "layover/public",
    loadChildren: () =>
      import("./public/public.module").then((m) => m.PublicModule),
    canActivate: [LoginGuard],
  },
  {
    outlet: "layover",
    path: "layover/main",
    loadChildren: () => import("./main/main.module").then((m) => m.MainModule),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static forRoot: any;
}
